export enum REQUEST_FACTORING_STEP {
  VIEW_INVOICES = 1,
  SUBMITTING_FACTORING = 2,
}
